import React from 'react';
export function ArticleHeader() {
  return <div className="max-w-3xl mx-auto px-4 mb-8" data-id="element-86">
      <div className="mb-4" data-id="element-87">
        <span className="text-[#2B4C7E] font-bold text-sm tracking-wider uppercase border-b-2 border-[#2B4C7E] pb-1" data-id="element-88">
          Persönlicher Bericht
        </span>
      </div>

      <h1 className="text-3xl md:text-5xl font-bold text-[#1B1B2F] leading-tight mb-4" data-id="element-89">
        „Ich dachte, ich rette meine Knochen, dabei habe ich meine Gefäße in
        Stein verwandelt"
      </h1>

      <h2 className="text-xl md:text-2xl text-[#4B5563] italic mb-8 leading-relaxed" data-id="element-90">
        Anna Mayer, 55 Jahre — Wie mein Versuch, gesund zu altern, fast in einer
        Katastrophe endete – und was jede Person ab 50 darüber wissen muss
      </h2>

      <div className="flex flex-col md:flex-row items-start md:items-center justify-between border-t border-b border-gray-200 py-6 gap-4" data-id="element-91">
        <div className="flex items-center gap-4" data-id="element-92">
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-lg border border-gray-300" data-id="element-93">
            A
          </div>
          <div data-id="element-94">
            <div className="font-bold text-[#1B1B2F]" data-id="element-95">Von Anna M.</div>
            <div className="text-sm text-[#6B7280]" data-id="element-96">
              Stuttgart · 55 Jahre alt
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-1 text-sm text-[#6B7280]" data-id="element-97">
          <div className="flex items-center gap-2 text-[#2B4C7E] font-medium" data-id="element-98">
            <img src="https://cdn.magicpatterns.com/uploads/ehoP8LkzJHev1vzxT6K1Pn/ЛИППЕРТ.jpg" alt="Dr. Lippert" className="w-12 h-12 rounded-full object-cover border border-[#2B4C7E]" data-id="element-99" />
            <span data-id="element-100">Medizinisch geprüft von Dr. Lippert</span>
          </div>
          <div className="flex items-center gap-4" data-id="element-101">
            <span data-id="element-102">⏱ 5-7 Min. Lesezeit</span>
            <span data-id="element-103">👁 38.471 Aufrufe</span>
          </div>
        </div>
      </div>
    </div>;
}